module.exports = __webpack_public_path__ + "static/tactics_notebook_tablet_hazena-c750bde7882c794a6c1e70cd56efc779.mp4";